import { useEffect } from 'react';

/**
 * Hide the iOS keyboard input accessory bar — the toolbar above the keyboard
 * with the up/down field-navigation arrows and the Done checkmark (#1579).
 *
 * It's a native iOS form affordance, not part of our web layout, so CSS can't
 * touch it; the only clean removal is the @capacitor/keyboard plugin's runtime
 * `setAccessoryBarVisible`. Native-only and fully fail-safe: on the web/PWA the
 * native check short-circuits, and on iPad / older iOS the call is a harmless
 * no-op. Mounted once, high in the tree (PageLayout).
 */
export default function useHideKeyboardAccessoryBar(): void {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } })
      .Capacitor;
    if (!cap?.isNativePlatform?.()) {
      return; // web / PWA — nothing to hide
    }
    void import('@capacitor/keyboard')
      .then(({ Keyboard }) => Keyboard.setAccessoryBarVisible({ isVisible: false }))
      .catch(() => {
        // Non-fatal — never let keyboard chrome tweaking break the app.
      });
  }, []);
}
